module.exports = __webpack_public_path__ + "img/save.163bf16c.jpg";